
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { RainfallRow } from '@/pages/customCalculation/model';
import BulkRainfallOperation from './BulkRainfallOperation.vue';

/**
 * 降雨条件設定の操作系（計算実行・放流量条件設定への遷移・一括操作）をまとめたパネル。
 * 広い画面ではテーブル横に、狭い画面ではダイアログ内に置くため、配置を持たない形で切り出している。
 */
@Component({
  components: {
    BulkRainfallOperation,
  },
})
export default class RainfallOperationPanel extends Vue {
  @Prop({ type: Array, required: true })
  data!: RainfallRow[];

  @Prop({ type: Boolean, default: false })
  isCalculating!: boolean;
}
